import { dataMember } from 'santee-dcts';
import { AddressField } from '../shipment-form/service/form-field';
import * as moment from 'moment';
import { GridDetails } from '../../sample-tracking/tracking-overview/interfaces/grid';

export class ShipmentSummaryInfo {
    @dataMember()
    public destination: AddressField;

    @dataMember()
    public shippedFrom: AddressField;

    @dataMember()
    public shippedToLabcorp: boolean;

    @dataMember()
    public airBillNo: string;

    @dataMember()
    public courier: string;

    @dataMember()
    public preparer: string;

    @dataMember()
    public date: string;

    @dataMember()
    public containers: string[] = [];
}

export class SiteShipmentSummaryData {
    @dataMember()
    public investigatorsiteshipmentId?: number;
    @dataMember()
    public userEmail?: string;
    @dataMember()
    public trackingNumber?: string;
    @dataMember()
    public fromOrgName?: string;
    @dataMember()
    public fromAddressLine1?: string;
    @dataMember()
    public fromAddressLine2?: string;
    @dataMember()
    public fromState?: string;
    @dataMember()
    public fromCity?: string;
    @dataMember()
    public fromPostalCode?: string;
    @dataMember()
    public fromCountryName?: string;
    @dataMember()
    public fromPhoneNumber?: string;
    @dataMember()
    public toOrgName?: string;
    @dataMember()
    public toAddressLine1?: string;
    @dataMember()
    public toAddressLine2?: string;
    @dataMember()
    public toState?: string;
    @dataMember()
    public toCity?: string;
    @dataMember()
    public toPostalCode?: string;
    @dataMember()
    public toCountryName?: string;
    @dataMember()
    public toPhoneNumber?: string;
    @dataMember()
    public courierName?: string;
    @dataMember()
    public preparerName?: string;
    @dataMember()
    public shipmentCreatedOn?: moment.MomentInput;
    @dataMember()
    public shippedOn?: moment.MomentInput;

    public containerData?: SiteShipmentContainerData[];
}

export class SiteShipmentContainerData {
    @dataMember()
    public investigatorsiteshipmentId?: number;
    @dataMember()
    public containerBarcodeRaw?: string;
    @dataMember()
    public protocolCode?: string;
    @dataMember()
    public visitDescription?: string;
    @dataMember()
    public accessionNumber?: string;
    @dataMember()
    public containerNumber?: string;
    @dataMember()
    public containerLabel1?: string;
    @dataMember()
    public containerLabel2?: string;
    @dataMember()
    public expectedReturnType?: string;
    @dataMember()
    public expectedReturnCondition?: string;
    @dataMember()
    public transferredBy?: string;
    @dataMember()
    public transferredTo?: string;
    @dataMember()
    public transferReason?: string;
    @dataMember()
    public hasPermission?: boolean;

    public containerBarcode?: string;

    public children?: SiteShipmentContainerData[];
    public cssClass?: string;
}

export interface SummaryByProtocol {
    protocol: string;
    containerData: SiteShipmentContainerData[];
    gridDetails?: GridDetails;
}